module.exports = "\n\n<app-org-event *ngFor=\"let event of events | async\" [event]=\"event\"></app-org-event>"